// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1GhB5","question":"styles_question__bV0Yu","inputVisibleButton":"styles_inputVisibleButton__2w7O3","note":"styles_note__3Z_NL"};